import './bootstrap';

const $body = $("body");

// Lazy loading div backgrounds
document.addEventListener("DOMContentLoaded", function() {
    var lazyloadImages;

    if ("IntersectionObserver" in window) {
        lazyloadImages = document.querySelectorAll(".lazy");
        var imageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    var div = entry.target;
                    if(div.dataset.center) {
                        div.style.backgroundImage = 'url("'+div.dataset.src+'")';
                        div.style.backgroundSize = 'cover';
                        div.style.backgroundPosition = 'center';
                    }else {
                        div.style.backgroundImage = 'url("'+div.dataset.src+'")';
                    }
                    div.classList.remove('lazy');
                    imageObserver.unobserve(div);
                }
            });
        });

        lazyloadImages.forEach(function (image) {
            imageObserver.observe(image);
        });

    }else {
        var lazyloadThrottleTimeout;
        lazyloadImages = document.querySelectorAll(".lazy");

        function lazyload () {
            if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
            }

            lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function(div) {
                    if(div.offsetTop < (window.innerHeight + scrollTop) && div.classList.contains('lazy')) {
                        if(div.dataset.center) {
                            div.style.backgroundImage = 'url("'+div.dataset.src+'")';
                            div.style.backgroundSize = 'cover';
                            div.style.backgroundPosition = 'center';
                        }else {
                            div.style.backgroundImage = 'url("'+div.dataset.src+'")';
                        }
                        div.classList.remove('lazy');
                    }
                });
                if(lazyloadImages.length == 0) {
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
            }, 20);
        }

        document.addEventListener("scroll", lazyload);
        window.addEventListener("resize", lazyload);
        window.addEventListener("orientationChange", lazyload);
    }
});

$(function () {


    mobileMenuFixer();
    logoSizeManager();
    window.onscroll = () => {
        mobileMenuFixer();
        logoSizeManager();
    };
    window.onresize = () => {
        logoSizeManager();
        mobileMenuFixer()
    };

    $body.on('click', '#navbar-menu-button', function () {
        $body.toggleClass("body-no-scroll");
        $(this).toggleClass("is-active");
    })
});


function mobileMenuFixer() {

    if ($body.width() <= 992) {

        let infoLine = $("#top-info-line");
        let mobileMenu = $("#mobileMainMenu");
        let top = infoLine.offset().top;
        const bottom = infoLine.height() + top;
        if (window.pageYOffset >= bottom) {

            mobileMenu.addClass("fixed-top");
        } else {
            mobileMenu.removeClass("fixed-top");
        }

    }
}

function logoSizeManager() {

    let rulerContainer = $("#standardNavbar");

    let logo = $(".a1-navbar-img");
    let siteName = $(".a1-company-name");

    if(!logo.hasClass('is-resizable')){
        return
    }
    let ruler = rulerContainer.offset();

    if (window.pageYOffset >= ruler.top) {
        logo.removeClass("increasedHeight");
        siteName.removeClass("increasedHeight");
    } else {
        if(window.innerWidth >= 991){
            logo.addClass("increasedHeight");
            siteName.addClass("increasedHeight");
        }else{
            logo.removeClass("increasedHeight");
            siteName.removeClass("increasedHeight");
        }
    }

}
